import * as FPT from '../utility/fpt';
import $ from 'jquery';

const CHILDREN_ACCESS_INDEX = 2;

function trackReportLink() {
  FPT.trackLinkClick('reportInappropriateContent');
}

export function addTrackReportLink() {
  const helpSecurity = $('.help_security');
  if (!helpSecurity || helpSecurity.length !== CHILDREN_ACCESS_INDEX) {
    return;
  }
  helpSecurity
    .children()
    [CHILDREN_ACCESS_INDEX].addEventListener('click', trackReportLink);
}

export function removeTrackReportLink() {
  const helpSecurity = $('.help_security');
  if (!helpSecurity || helpSecurity.length !== CHILDREN_ACCESS_INDEX) {
    return;
  }
  helpSecurity
    .children()
    [CHILDREN_ACCESS_INDEX].removeEventListener('click', trackReportLink);
}
